import React, { useEffect, useState } from 'react';

import DataSource from 'devextreme/data/data_source';
import 'devextreme/data/odata/store';

import Chart, {
  ValueAxis,
  ArgumentAxis,
  CommonPaneSettings,
  Grid,
  Series,
  Label,
  Legend,
  Size,
  Border,
  Tooltip,
  Export,
  LoadingIndicator
} from 'devextreme-react/chart';

import SelectBox from 'devextreme-react/select-box';

import { years, months } from './data.js';
import http from '../../utils/http.js';
import { formatToMoney, getMonthName } from '../../utils/common';
import Title from '../../components/shared/Title.jsx';
import BlockHeader from '../../components/shared/BlockHeader.jsx';
import { chartTypes, palettes } from '../../data/app.js';

const BillsByDays = props => {

  const [type, setType] = useState('line');
  const [palette, setPalette] = useState('Material');

  const [total, setTotal] = useState(0);
  const [data, setData] = useState([]);
  const [customDate, setCustomDate] = useState({
    month: 0,
    year: 0
  });

  const onValueChanged = e => {

    setCustomDate({
      ...customDate,
      [e.element.id]: e.value
    })

  };

  useEffect(() => {

    http(`reports/bills/sales/days?year=${customDate.year}&month=${customDate.month}`).asGet().then(resp => {      
      setData(resp);
      setTotal(resp.reduce((acc, cur) => acc + cur.total, 0));
    })
  }, [customDate]);

  const customizeLabel = (e) => {
    return `${e.valueText}`;
  }

  function customizeTooltip(arg) {
    return {
      text: `$ ${arg.valueText}`
    };
  }

  const title = 'Reporte de Ventas por día';

  return (
    <div className="container">
      <Title title={title} />
      <BlockHeader title={title}>
      <span>Estilo: </span>
        <SelectBox
          text='Seleccione'
          items={chartTypes}
          defaultValue={'line'}
          onValueChanged={e => setType(e.value)} />
        <span>Tema: </span>
        <SelectBox
          text='Seleccione'
          items={palettes}
          defaultValue={'Material'}
          onValueChanged={e => setPalette(e.value)} />
      </BlockHeader>
      <div style={{ display: 'flex' }}>
        <div className="action">
          <div className="label">Seleccione un año:
          </div>
          <SelectBox
            width={150}
            id="year"
            items={years}
            defaultValue={0}
            onValueChanged={onValueChanged} />
        </div>
        <div className="action">
          <div className="label">Seleccione un mes:
          </div>
          <SelectBox
            width={150}
            id="month"
            valueExpr="id"
            displayExpr="name"
            items={months}
            defaultValue={0}
            onValueChanged={onValueChanged} />

        </div>
      </div>

      <div id="chart-demo">
        <Chart
          title={`Ventas de mes ${customDate.month} del año ${customDate.year}`}
          dataSource={data}  palette={palette}>
          <Size height={420} />
          <ValueAxis
            grid={{ opacity: 0.2 }}
            valueType="numeric"
          >
            <Label customizeText={customizeLabel} />
          </ValueAxis>
          <ArgumentAxis type="discrete">
            <Grid visible={true} opacity={0.5} />
          </ArgumentAxis>
          <CommonPaneSettings>
            <Border
              visible={true}
              width={2}
              top={false}
              right={false}
            />
          </CommonPaneSettings>
          <Series
            argumentField="dateday"
            valueField="total"
            type={type}
          />
          <Legend visible={false} />
          <Export enabled={true} />
          <Tooltip
            enabled={true}
            customizeTooltip={customizeTooltip} />
          <LoadingIndicator enabled={true} />
        </Chart>
        <div className="action">
          <div className="label">Total: {formatToMoney(total)}</div>
        </div>

      </div>
    </div>);

}



export default BillsByDays;
